import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import $ from "jquery";
const ob = {
  Id: null,
  DirectTrust: false,
  IDProofingRequired: false,
  TrustedAgentAgreement: false,
  TwoFactorAuth: false,
  ApplicationAccessSESConnect: false,
  DirectorySharing: false,
  ApplicationAccessXDR: false,
  ApplicationAccessENS: false,
  RegistrationAPIActive: false,
  EmailForwardingTypeBox: false,
  EmailForwardingType: false,
  DirectRoute: false,
};

const DetailsCustomer = ({ userDetails, CloseDetailUser, userEdit }) => {
  const navigate = useNavigate();
  const {
    isUserLogedIn,
    userRole,
    userToken,
    setCustomerObj,
    SetSharedObject,
  } = useUserStore((state) => ({
    isUserLogedIn: state.isUserLogedIn,
    userRole: state.userRole,
    userToken: state.userToken,
    setCustomerObj: state.setCustomerObj,
    SetSharedObject: state.SetSharedObject,
  }));
  const [answers, setAnswers] = useState(null);
  const [successFlag, setSuccessFlag] = useState(false);
  const [submitFlag, setSubmitFlag] = useState(false);
  const [checkBoxes, setCheckBoxes] = useState(null);
  const [processing, setProcessing] = useState(false);
  const setAnswer = async (questionId, answer) => {
    if (questionId === "EmailForwardingTypeBox") {
      if (answer) {
        checkBoxes.EmailForwardingType = 2;
      } else {
        checkBoxes.EmailForwardingType = 0;
      }
    } else if (questionId === "DirectRoute") {
      if (answer) {
        checkBoxes.EmailForwardingType = 1;
      } else {
        checkBoxes.EmailForwardingType = 0;
      }
    }
    await setCheckBoxes({ ...checkBoxes, [questionId]: answer });
  };
  useEffect(() => {
    SetErrMsg(false);
    let o = {};
    if (userDetails) {
      o = {
        Id: userDetails.id,
        DirectTrust: userDetails.directTrust,
        IDProofingRequired: userDetails.idProofingRequired,
        TrustedAgentAgreement: userDetails.trustedAgentAgreement,
        TwoFactorAuth: userDetails.twoFactorAuth,
        ApplicationAccessSESConnect: userDetails.applicationAccessSESConnect,
        DirectorySharing: userDetails.directorySharing,
        ApplicationAccessXDR: userDetails.applicationAccessXDR,
        ApplicationAccessENS: userDetails.applicationAccessENS,
        RegistrationAPIActive: userDetails.registrationAPIActive,
        EmailForwardingTypeBox:
          userDetails.emailForwardingType === 2 ? true : false,
        EmailForwardingType: userDetails.emailForwardingType,
        DirectRoute: userDetails.emailForwardingType === 1 ? true : false,
      };
    }
    setCheckBoxes(o);
    setAnswers(userDetails);
    setSuccessFlag(false);
    setSubmitFlag(false);
    return () => {
      setCheckBoxes(null);
      SetErrMsg(false);
      setCheckBoxes(ob);
    };
  }, [userDetails]);
  const [errMsg, SetErrMsg] = useState(false);
  const [msg, SetMsg] = useState("");
  const UpdateCustomer = async () => {
    setSuccessFlag(false);
    SetErrMsg(false);
    if (
      checkBoxes.RegistrationAPIActive &&
      checkBoxes.IDProofingRequired == true &&
      checkBoxes.TrustedAgentAgreement == false
    ) {
      SetMsg(
        "Registration API not allowed without TA Agreement when IDProofing is required."
      );
      SetErrMsg(true);
      return;
    }
    if (checkBoxes.DirectTrust && checkBoxes.IDProofingRequired == false) {
      SetMsg("ID Proofing is required for DirectTrust.");
      SetErrMsg(true);
      return;
    }
    if (
      checkBoxes.IDProofingRequired == false &&
      checkBoxes.TrustedAgentAgreement
    ) {
      SetMsg("Trusted Agent Agreement not allowed without ID Proofing.");
      SetErrMsg(true);
      return;
    }
    if (
      checkBoxes.RegistrationAPIActive &&
      !checkBoxes.ApplicationAccessSESConnect
    ) {
      SetMsg("Registration API  not allowed without SESConnect license.");
      SetErrMsg(true);
      return;
    }
    setSubmitFlag(true);
    setProcessing(true);
    let call = "/customers/UpdateCustomer";
    const res = await CallAPI(call, checkBoxes, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let vendors = await getCustomers();
      setSuccessFlag(true);
    } else if (res.status === "SERVERERROR") {
      SetMsg(
        "Customer cannot be updated at this time. Please contact customer support for further assistance."
      );
      SetErrMsg(true);
      setProcessing(false);
    }
  };
  const getCustomers = async () => {
    setProcessing(true);
    let call = "/users/GetVendors";
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      setProcessing(false);
      SetSharedObject("vendorsObj", res.data.data);
      SetSharedObject("refreshCustObj", Date.now());
    } else if (res.status === "SERVERERROR") {
      SetMsg(
        "An Error Occurred. Please contact customer support for further assistance."
      );
      SetErrMsg(true);
      setProcessing(false);
    }
  };
  function setSesConnect(val) {
    if (val === true) {
      setCheckBoxes({ ...checkBoxes, ApplicationAccessSESConnect: val });
      setAnswers({ ...answers, ApplicationAccessSESConnect: val });
    } else {
      setCheckBoxes({
        ...checkBoxes,
        RegistrationAPIActive: val,
        ApplicationAccessSESConnect: val,
      });
      setAnswers({
        ...answers,
        ApplicationAccessSESConnect: val,
        RegistrationAPIActive: val,
      });
    }
  }
  function closeCustomerDetails() {
    $("#detailsCustomerModal").modal("hide");
    setSuccessFlag(false);
  }
  function formatPhoneNumber(value) {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  }
  return (
    <div className="DetailsCustomer">
      <div
        className="modal fade"
        id="detailsCustomerModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="DetailsCustomer"
        aria-hidden="false"
      >
        <div className="modal-dialog modal-dialog-slideout">
          <div className="modal-content">
            <div className="modal-header">
              <div
                className="modal-title spacer-inline text-size3"
                id="myModalLabel"
              >
                Details
              </div>
              <button
                type="button"
                className="close"
                onClick={(e) => $("#detailsCustomerModal").modal("hide")}
              >
                <span aria-hidden="false">&times;</span>
              </button>
            </div>

            <form>
              <div className="modal-body">
                <div className="modal-content-body container">
                  <div className="details-header blk-clr">
                    <i className="bi bi-buildings-fill text-size5"></i>
                    <div className="text-size6 ft-wt blk-clr">
                      {answers?.name}
                    </div>
                    <div className="sp-margin1">
                      <i class="bi bi-pencil-square sp-margin5"></i>
                      <a
                        href="javascript:void(0);"
                        onClick={(el) => userEdit(answers)}
                      >
                        EDIT
                      </a>
                    </div>
                  </div>
                  <div className="field-wrapper">
                    <div>
                      <label>Address:</label>
                      <span className="sp-margin5 spacer-inline">
                        {answers?.billingAddress?.street1}
                        {answers?.billingAddress?.street2},
                      </span>
                      <span className="sp-margin5 spacer-inline">
                        {answers?.billingAddress?.city},
                      </span>
                      <span className="sp-margin5 spacer-inline">
                        {answers?.billingAddress?.state}
                      </span>
                      <span className="sp-margin5 spacer-inline">
                        {answers?.billingAddress?.country}
                      </span>
                      <span className="sp-margin5 spacer-inline">
                        {answers?.billingAddress?.zip}
                      </span>
                    </div>
                    <div>
                      <label>Phone:</label>
                      <span className="sp-margin5">
                        {formatPhoneNumber(
                          answers?.billingAddress?.phone?.substring(0, 10)
                        )}
                      </span>
                      <label className="sp-margin5">Ext:</label>
                      {answers?.billingAddress?.phone?.substring(
                        10,
                        answers?.billingAddress?.phone.length
                      )}
                    </div>
                    <div>
                      <label>Fax:</label>
                      <span className="sp-margin5">
                        {formatPhoneNumber(
                          answers?.billingAddress?.fax?.substring(0, 10)
                        )}
                      </span>
                      <label>Ext:</label>
                      {answers?.billingAddress?.fax?.substring(
                        10,
                        answers?.billingAddress?.fax.length
                      )}
                    </div>
                  </div>
                  <hr />

                  {/*Customer Info*/}
                  <section className="field-wrapper">
                    <label for="Domain">Domain:</label>
                    <span>{answers?.baseDomain?.name}</span>
                    <br />
                    <label for="TotalOrgs">Total Organizations:</label>
                    {answers?.org?.length}
                    <br />
                    <label for="CreatedBy">Created By:</label>
                    <span>{answers?.createdBy}</span>
                    <br />
                    <label for="DateCreated">Date Created:</label>
                    <span>{answers?.dateCreated}</span>
                  </section>

                  {/*Customer Identity Verification*/}
                  <section className="field-wrapper label-divider">
                    <div className="sp-margin7 spacer-inline">
                      Verifications
                    </div>
                  </section>
                  <div className="field-wrapper">
                    <input
                      type="checkbox"
                      className="spacer-margin5"
                      name="DirectTrust"
                      id="DirectTrust"
                      checked={checkBoxes?.DirectTrust}
                      value={checkBoxes?.DirectTrust}
                      onClick={(el) =>
                        setAnswer("DirectTrust", el.target.checked)
                      }
                    />
                    <label className="spacer-margin8">DirectTrust</label>
                    <br />
                    <input
                      type="checkbox"
                      className="spacer-margin5"
                      name="IDProofingRequired"
                      id="IDProofingRequired"
                      checked={checkBoxes?.IDProofingRequired}
                      value={checkBoxes?.IDProofingRequired}
                      onClick={(el) =>
                        setAnswer("IDProofingRequired", el.target.checked)
                      }
                    />
                    <label className="spacer-margin8">
                      ID Proofing Required
                    </label>
                    <br />
                    <input
                      type="checkbox"
                      className="spacer-margin5"
                      name="TrustedAgentAgreement"
                      id="TrustedAgentAgreement"
                      checked={checkBoxes?.TrustedAgentAgreement}
                      value={checkBoxes?.TrustedAgentAgreement}
                      onClick={(el) =>
                        setAnswer("TrustedAgentAgreement", el.target.checked)
                      }
                    />
                    <label className="spacer-margin8">Trusted Agent</label>
                  </div>

                  {/*Customers list of services*/}
                  <section className="field-wrapper label-divider">
                    <div className="sp-margin7 spacer-inline">Permissions</div>
                    <div className="sp-margin3 spacer-inline float-r">
                      <details data-popover="up">
                        <summary>
                          <i className="bi bi-info-circle text-size9"></i>
                        </summary>
                        <div>
                          <div className="icon-sign or-clr">
                            <i className="bi bi-info-circle"></i>
                          </div>
                          <p className="sp-margin4">
                            When you set permissions at the customer level, they
                            will become active and can be enabled or disabled at
                            the organization level. If you later deselect these
                            permissions, they will no longer be accessible to
                            any organization.
                          </p>
                        </div>
                      </details>
                    </div>
                  </section>

                  <div className="field-wrapper">
                    <input
                      type="checkbox"
                      className="spacer-margin5"
                      name="ApplicationAccessSESConnect"
                      id="ApplicationAccessSESConnect"
                      checked={checkBoxes?.ApplicationAccessSESConnect}
                      value={checkBoxes?.ApplicationAccessSESConnect}
                      onClick={(el) => setSesConnect(el.target.checked)}
                    />
                    <label className="spacer-margin8">SESConnect</label>

                    {checkBoxes?.ApplicationAccessSESConnect === true ? (
                      <div>
                        <input
                          type="checkbox"
                          className="spacer-margin5"
                          name="RegistrationAPIActive"
                          id="RegistrationAPIActive"
                          checked={checkBoxes?.RegistrationAPIActive}
                          value={checkBoxes?.RegistrationAPIActive}
                          onClick={(el) =>
                            setAnswer(
                              "RegistrationAPIActive",
                              el.target.checked
                            )
                          }
                        />
                        <label className="spacer-margin8">
                          Registration API
                        </label>
                      </div>
                    ) : null}
                    <br />
                    <input
                      type="checkbox"
                      className="spacer-margin5"
                      name="DirectorySharing"
                      id="DirectorySharing"
                      checked={checkBoxes?.DirectorySharing}
                      value={checkBoxes?.DirectorySharing}
                      onClick={(el) =>
                        setAnswer("DirectorySharing", el.target.checked)
                      }
                    />
                    <label className="spacer-margin8">
                      Share Directory Listing
                    </label>
                    <br />
                    <input
                      type="checkbox"
                      className="spacer-margin5"
                      name="DirectRoute"
                      id="DirectRoute"
                      checked={checkBoxes?.DirectRoute}
                      value={checkBoxes?.DirectRoute}
                      disabled={checkBoxes?.EmailForwardingTypeBox}
                      onClick={(el) =>
                        setAnswer("DirectRoute", el.target.checked)
                      }
                    />
                    <label className="spacer-margin8">DirectRoute</label>
                    <br />
                    <input
                      type="checkbox"
                      className="spacer-margin5"
                      name="EmailForwardingTypeBox"
                      id="EmailForwardingTypeBox"
                      checked={checkBoxes?.EmailForwardingTypeBox}
                      value={checkBoxes?.EmailForwardingTypeBox}
                      disabled={checkBoxes?.DirectRoute}
                      onClick={(el) =>
                        setAnswer("EmailForwardingTypeBox", el.target.checked)
                      }
                    />
                    <label className="spacer-margin8">
                      Advanced DirectRoute
                    </label>
                    <br />
                    <input
                      type="checkbox"
                      className="spacer-margin5"
                      name="ApplicationAccessENS"
                      id="ApplicationAccessENS"
                      checked={checkBoxes?.ApplicationAccessENS}
                      value={checkBoxes?.ApplicationAccessENS}
                      onClick={(el) =>
                        setAnswer("ApplicationAccessENS", el.target.checked)
                      }
                    />
                    <label className="spacer-margin8">Notify</label>
                    <br />
                    <input
                      type="checkbox"
                      className="spacer-margin5"
                      name="ApplicationAccessXDR"
                      id="ApplicationAccessXDR"
                      checked={checkBoxes?.ApplicationAccessXDR}
                      value={checkBoxes?.ApplicationAccessXDR}
                      onClick={(el) =>
                        setAnswer("ApplicationAccessXDR", el.target.checked)
                      }
                    />
                    <label className="spacer-margin8">XDR-Access</label>
                    <br />
                    <input
                      type="checkbox"
                      className="spacer-margin5"
                      name="AllowTwoFactor"
                      id="AllowTwoFactor"
                      checked={checkBoxes?.TwoFactorAuth}
                      value={checkBoxes?.TwoFactorAuth}
                      onClick={(el) =>
                        setAnswer("TwoFactorAuth", el.target.checked)
                      }
                    />
                    <label className="spacer-margin8">
                      Two Factor Authentication
                    </label>
                  </div>
                  {errMsg ? (
                    <div className="alert alert-danger" role="alert">
                      {msg}
                    </div>
                  ) : null}
                  {submitFlag && successFlag ? (
                    <div className="alert alert-success" role="alert">
                      Customer has been updated successfully.
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={UpdateCustomer}
                >
                  Update
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={closeCustomerDetails}
                >
                  Close
                </button>
              </div>
              {processing ? <div className="loading"></div> : null}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsCustomer;
